// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.filepond--credits {
    display: none !important;
}
.filepond--drop-label {
    /* background-color: #1e1e1e; */
    background-color: transparent !important;
}

/* the text color of the drop label*/
.filepond--drop-label > label {
    color: #ccc;
}

/* use a hand cursor intead of arrow for the action buttons */
.filepond--file-action-button {
    cursor: pointer;
}

/* underline color for "Browse" button */
.filepond--label-action {
    text-decoration-color: #aaa;
}

/* the border radius of the drop area */
.filepond--panel-root {
    border-radius: 0.5em;
}

/* the border radius of the file item */
.filepond--item-panel {
    border-radius: 0.5em;
}


/* bordered drop area */
/* the background color of the filepond drop area */
.filepond--panel-root {
    background-color: transparent !important;
    border: none !important;
}
.filepond--item-panel {
    background-color: #555;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
